
import Banner from "../../components/Banner/Banner";
import enteteImage from "../../assets/entete.webp";
import MyForm from "../../components/ContactForm/ContactForm";
import "./Contact.scss";


function Contact() {
  return (
    <div>
      <main>
        <Banner
          img={enteteImage}
          title="Pour vous, je conçois et réalise des applications qui répondent à vos besoins."
          subtitle="Contactez-moi pour discuter de vive voix des enjeux de votre projet et de ce qu'il doit vous apporter en termes de valeur et d'expérience utilisateur."
        />
        <div className="Contact">
          <MyForm />
        </div>
      </main>
    </div>
  );
}
export default Contact;
